<template>
  <div>
    <el-dialog title="编辑证书" :close-on-click-modal="false" :visible.sync="display" size="small" @close='closeDialog'>
      <el-row>
        <el-alert title="请先添加按钮，再点击确定按钮才能完成修改" type="warning" :closable="false" show-icon></el-alert>
      </el-row>
      <el-row style="margin: 10px 0;">
        <el-select v-model="text" filterable allow-create placeholder="请输入证书名称" size="small" style="width:400px;">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-button @click="add" size="small">添加</el-button>
      </el-row>
      <el-row class="regulation">
        <ul>
          <li v-for="(item,index) in list" :key="index">{{item.name}}<a @click="del(index)" style="float:right;cursor: pointer">删除</a>
          </li>
        </ul>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    certificateList
  } from '~/api/common';
  export default {
    props: {
      data: {
        type: Array,
        default: []
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        list: [],
        display: false,
        text: '',
        options: [],
      };
    },
    watch: {
      data: function (value) {
        this.list = [];
        value.forEach(el => {
          this.list.push(Object.assign({}, el));
        });
      },
      visible: function (value) {
        this.display = value;
      },
    },
    mounted() {
      certificateList().then(m => {
        if (m.errcode == 0) {
          this.options = m.data;
        }
      });
    },
    methods: {
      del(index) {
        this.list.splice(index, 1);
      },
      add() {
        if (this.text == '') {
          this.$message.error('请输入证书名称');
          return;
        }
        this.list.push({
          name: this.text
        });
        this.text = '';
      },
      cancel() {
        this.display = false;
      },
      confirm() {
        this.display = false;
        this.$emit('change', this.list);
      },
      closeDialog() {
        this.$emit('visibleChange', false);
      },
    }
  };
</script>
<style scoped>
</style>